<template>
  <footer class="i-coaching-upsell-footer">
    <div class="container">
      <p>
        © {{ new Date().getFullYear() }} JobTest.org · <a href="#">Privacy Policy</a> ·
        <a href="#">Terms of Service</a> ·
        <a href="#">Contact</a>
      </p>
      <p style="margin-top: 6px">
        Salary increase figures reflect median outcomes reported by clients in follow-up surveys (n=2,847). Individual
        results vary and are not guaranteed.
      </p>
    </div>
  </footer>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.i-coaching-upsell-footer {
  border-top: 1px solid var(--border);
  padding: 28px 24px;
  text-align: center;
  font-size: 0.78rem;
  color: var(--muted);

  a {
    color: var(--muted);
    text-decoration: underline;
  }
}
</style>
